import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft as back, faFilePdf as pdf } from '@fortawesome/free-solid-svg-icons';
import config from '../../config';
import ExhibitorActivities from './ExhibitorActivities';


const ExhibitorMain = ({ exhibitor }) => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const lang = i18n.language;

	const bytes2string = (bytes) => {
		if(bytes > 1024 * 1024) {
			return Math.round(bytes/(1024*1024)) + ' Mb';
		} else if(bytes > 1024) {
			return Math.round(bytes/1024) + ' Kb';
		} else {
			return bytes + ' bytes'
		}
	};

	return (
		<div className='Exhibitor-main'>
			<div className='desktop'>
				<h1>{exhibitor.name[lang]}</h1>

				{exhibitor.brief[lang] &&
				<React.Fragment>
					<p>{exhibitor.brief[lang]}</p>
					<p>&nbsp;</p>
				</React.Fragment>}
			</div>

			{exhibitor.brand &&
			<React.Fragment>
				<h2>{t('exhibitor.brand')}</h2>
				<p>{exhibitor.brand}</p>
				<p>&nbsp;</p>
			</React.Fragment>}

			{exhibitor.about[lang] &&
			<React.Fragment>
				<h2>{t('exhibitor.about')}</h2>
				{exhibitor.about[lang].split('\n').map((line, index) => <p key={index}>{line}</p>)}
				<p>&nbsp;</p>
			</React.Fragment>}

			{exhibitor.descr[lang] &&
			<React.Fragment>
				<h2>{t('exhibitor.descr')}</h2>
				{exhibitor.descr[lang].split('\n').map((line, index) => <p key={index}>{line}</p>)}
				<p>&nbsp;</p>
			</React.Fragment>}

			<ExhibitorActivities exhibitor={exhibitor} title='exhibitor.activities'/>

			{(exhibitor.event.is_files_available && exhibitor.files.length > 0) &&
			<React.Fragment>
				<h2>{t('exhibitor.files')}</h2>
				<ul className='fa-ul'>
				{exhibitor.files.map((file, index) => (
					<li key={index}>
						<FontAwesomeIcon icon={pdf} className='fa-li' size='xl' style={{color:'var(--accent-color)'}}/>
						<b>{file.name[lang]}</b><br/>
						{file.descr[lang] && <span>{file.descr[lang]}<br/></span>}
						<a target='_blank' rel='noreferrer' href={config.FILES_URL + file.base + file.file}>{t('exhibitor.download')}</a>
						&nbsp;<small>({bytes2string(file.size)})</small>
						<br/><br/>
					</li>
				))}
				</ul>
			</React.Fragment>}

			<div className='button' onClick={() => navigate('../exhibitors/' + exhibitor.event._id)}>
				<div className='button-icon'>
					<FontAwesomeIcon icon={back} size='lg'/>
				</div>
				<div className='button-text'>
					{t('exhibitor.back')}
				</div>
			</div>
		</div>
	);
};

ExhibitorMain.propTypes = {
    exhibitor: PropTypes.object.isRequired,
};

export default ExhibitorMain;
